<template>
  <v-sheet :height="this.$root.windowHeight" :width="this.$root.windowWidth">
    <v-container class="fill-height" v-if="!selected">
      <v-col align="center">
        <v-row align="center" justify="center" class="mb-12">
          <h1>
            {{ headline }}
          </h1>
        </v-row>
        <v-row align="center" justify="center">
          <v-col align="center">
            <PieChart :labels="this.toLanguageNames(Object.keys(stats.top_languages))"
                      :values="Object.values(stats.top_languages)"
                      :selected.sync="selected"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-container>
    <v-container class="fill-height overflow-x-hidden" v-else>
      <v-row align="center" justify="center">
        <MovieWallCard :records="movies"
                   :loaded="loaded"
                   :headline="movies.length + ' en ' + selected"
                   :selected.sync="selected"
                   class="mb-3"/>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import PieChart from "@/components/charts/PieChart";
import axios from "axios";
import MovieWallCard from "@/components/MovieWallCard";
import {languageNames} from "@/utils/data";

const BASE_URL = process.env.VUE_APP_API_URL

export default {
  name: "TopLanguagesWrapper",
  components: {MovieWallCard, PieChart},
  props: ['headline', 'stats'],
  data: () => ({
    selected: null,
    movies: [],
    languageCodes: {},
    loaded: false,
    count: 0,
  }),
  methods: {
    toLanguageNames(languages) {
      let temp = new Array(languages.length);
      languages.forEach((iso, index) => {
        let name = languageNames[iso]['nombre']
        name = name.charAt(0).toUpperCase() + name.slice(1)
        this.languageCodes[name] = iso
        temp[index] = name
      })
      return temp
    },
    fetchMovies() {
      this.loaded = false
      this.count = 0
      axios(
          {
            method: 'get',
            url: BASE_URL + 'stats/movies/',
            params: {
              page_size: 0,
              token: this.$route.params['token'],
              user_id: this.$route.params['user_id'],
              year: this.$route.params['year'],
              language: this.languageCodes[this.selected],
            }
          }
      ).then(res => {
        this.movies = res.data
        this.count = this.movies.length
        this.loaded = true
      })
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    selected: function (newVal, oldVal) {
      if (newVal) {
        this.fetchMovies()
      } else {
        this.movies = []
      }
    }
  }
}
</script>

<style scoped>

</style>
